import React from 'react';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { TDragAndDropProps } from 'types/Components/Common/DragAndDrop';

/**
 * Common catainer for drag and drop
 * 
 * @param {number|string} id - unique identifier
 * @param {string} className - optional class name will be used instead of all existing class names
 * @param {DraggableChildrenFn} renderItem - item to render
 * @param onDragEnd
 *  
 * points to remember
 * - if the parent has any positioning other than relative then use this to pass the draggable
 *  other wise dragging may be cause unwanted issues
 */

export default function DragAndDropContainer({
    id,
    className=`tw-max-w-full tw-border tw-rounded-sm tw-h-[319px] tw-p-2 tw-space-y-2 tw-overflow-auto tw-relative tw-transform-none`,
    children,
    renderItem,
    onDragEnd
}: TDragAndDropProps){
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="columnArrange" renderClone={renderItem || undefined}>
            {
            (provided) =>
            <div ref={provided.innerRef} className={className} >
                {children}
                {provided.placeholder}
            </div> 
            }
            </Droppable> 
        </DragDropContext>
    )
}